import highlight_1 from '@/assets/highlight_1.jpeg';

// Hero Section with White Background
interface HeroSectionProps {
  title?: string;
  description?: string;
  long?: string;
}

function HeroSection({ title = "", description = "", long = "" }: HeroSectionProps) {


  return (
<section className="relative min-h-[40vh] md:min-h-[60vh] overflow-hidden py-16  md:py-24">

    {/* Background Image */}
    <div className="absolute inset-0">
        <img
            src={highlight_1}
            alt="Background"
            className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/60"></div>
    </div>

    {/* Content */}
    <div className="relative z-10 flex items-center px-6 md:px-12 mt-8 lg:px-20">
        <div className="w-full max-w-5xl">

            <div className="space-y-5 md:space-y-7 max-w-3xl">

                <h1 className="font-black text-4xl sm:text-5xl lg:text-6xl text-white leading-tight tracking-tight break-words">
                    {title}

                    <span className="block red-gold-gradient-text mt-2">
                        {description}
                    </span>
                </h1>

                <p className="text-white/80 text-sm sm:text-base leading-relaxed break-words">
                    {long}
                </p>

            </div>
        </div>
    </div>
</section>
  );
}

export default HeroSection;